import { PulseBaseProvider } from '../../base-classes';

const _nowContentCacheKey = 'nowContent';
const _nowContentSettingsCacheKey = 'nowContentSettings';
const _nowContentUrl='/data/content/v3';
const _nowSettingsUrl = '/data/content/settings/v3/appinstanceid={appInstanceId}';

export class NowContentProvider extends PulseBaseProvider {
    constructor(baseUrl, authId, secret, options, logger) {
        super(baseUrl, authId, secret, options, logger);
        this.storage.sync[_nowContentCacheKey] = this.nowContentSyncer.bind(this);
        this.storage.sync[_nowContentSettingsCacheKey] = this.nowContentSettingsSync.bind(this);
    }

    async nowContentSyncer(params) {
        const { id, syncParams, resolve, reject } = params;
        let queryParams = {
            ...syncParams.stdParameters
            ,verbose: syncParams.verbose
            ,locationType: 'latitudelongitude'
            ,location: `${syncParams.latitude},${syncParams.longitude}`
        };
        return await super.syncData(syncParams.key, id, queryParams, _nowContentUrl, resolve, reject, null, syncParams.pulseApi,null, null, true, 86400000);
    }


    async getNowContent(appInstanceId, latitude, longitude, stdParameters, verbose, refresh = false) {
        const syncParams = {
            appInstanceId
            ,latitude
            ,longitude
            ,verbose: !!verbose
            ,refresh
        };
        const id = JSON.stringify(syncParams);

        //Add the standard parameters after generating the ID because they shouldn't be part of the cache key

        syncParams.stdParameters = stdParameters;

        if (refresh)
        {
            super.removeFromStorage(_nowContentCacheKey, id);
        }
        return await super.loadFromStorage(_nowContentCacheKey, id, syncParams);
    }

    async nowContentSettingsSync(params) {
        const { id, syncParams, resolve, reject } = params;
        const { appInstanceId, latitude, longitude } = syncParams;
        let queryParams = {
            ...syncParams.stdParameters,
            verbose: syncParams.verbose,
            locationType: 'latitudelongitude',
            location: `${latitude},${longitude}`
        };
        const url = _nowSettingsUrl.replace('{appInstanceId}', appInstanceId);

        return await super.syncData(syncParams.key, id, queryParams, url, resolve, reject, null, syncParams.pulseApi);
    }

    async getNowContentSettings(appInstanceId, stdParameters, verbose, refresh, latitude, longitude) {
        const syncParams = {
            verbose: !!verbose,
            refresh,
            appInstanceId,
            latitude,
            longitude,
            cultureInfo: stdParameters?.cultureinfo
        };

        const id = JSON.stringify(syncParams);

        //Add the standard parameters after generating the ID because they shouldn't be part of the cache key


        syncParams.stdParameters = stdParameters;

        if (refresh) {
            super.removeFromStorage(_nowContentSettingsCacheKey, id);
        }
        return await super.loadFromStorage(_nowContentSettingsCacheKey, id, syncParams);
    }

    async updateNowContentSettings(appInstanceId, contentSettings, stdParameters, verbose) {
        const url = _nowSettingsUrl.replace('{appInstanceId}', appInstanceId);

        const queryParams = {
            verbose: !!verbose,
            ...stdParameters
        };

        const data = JSON.stringify(contentSettings);
        return await super.putData(queryParams, data, url, true, null);
    }
}
